import { initializeApp } from '@firebase/app';
import { getAuth } from '@firebase/auth';
import { firebaseConfig } from './config';

const Firebase = initializeApp(firebaseConfig);

export const auth = getAuth;
export default Firebase;
